<kendo-formfield>
    <kendo-label [text]="caption | translate">
    </kendo-label>
    <kendo-combobox #listComboCity [ngClass]="{'fx-fill': settings.fxFill}" [data]="valuesList$ | async"
     [valuePrimitive]="true" [formControl]="control" [allowCustom]="true"
        [filterable]="true" (valueChange)="onChange($event)" (filterChange)="filterChange($event)">

        <ng-template kendoComboBoxItemTemplate let-listItem>
            <div fxFill class="list-item-display" fxLayout="row">
                {{ listItem }}
            </div>
        </ng-template>

        <ng-template kendoDropDownListNoDataTemplate>
            <div *ngIf="!(term$|async)">{{'kendo.combobox.startTyping' | translate}}</div>
            <div *ngIf="term$|async">{{'kendo.combobox.noMatch' | translate}}</div>
        </ng-template>
    </kendo-combobox>
</kendo-formfield>
